// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--22w0l";
export var footerLogo = "styles-module--footer-logo--1uGxC";
export var footerInfo = "styles-module--footer-info--QfvSw";
export var footerSocials = "styles-module--footer-socials--2fEF0";
export var footerBackdrop = "styles-module--footer-backdrop--2XjXD";
export var footerElement = "styles-module--footer-element--753E9";